import { z } from 'zod';
export const caseStatusSchema = z.enum(['OPEN', 'DIAGNOSING', 'IDENTIFIED', 'RESOLVED', 'CLOSED', 'ABANDONED']);
export const stepKindSchema = z.enum(['OBSERVATION', 'HYPOTHESIS', 'TEST', 'RESULT', 'ACTION', 'NOTE']);
export const caseCreateSchema = z.object({
    title: z.string().min(3).max(200),
    symptom: z.string().min(3).max(4000),
    severity: z.number().int().min(1).max(4).default(3),
    /** Site / device references as titles or [[wikilinks]]. */
    site: z.string().max(200).optional(),
    devices: z.array(z.string().max(200)).max(20).default([]),
    runbookKey: z.string().max(120).optional(),
});
export const caseStepSchema = z.object({
    kind: stepKindSchema,
    summary: z.string().min(1).max(2000),
    detail: z.record(z.unknown()).optional(),
});
export const casePatchSchema = z.object({
    status: caseStatusSchema.optional(),
    severity: z.number().int().min(1).max(4).optional(),
    title: z.string().min(3).max(200).optional(),
    site: z.string().max(200).nullable().optional(),
    devices: z.array(z.string().max(200)).max(20).optional(),
    runbookKey: z.string().max(120).nullable().optional(),
});
export const caseCloseSchema = z.object({
    rootCause: z.string().min(3).max(4000),
    resolution: z.string().min(3).max(4000),
    followUp: z.array(z.string().max(500)).max(20).default([]),
    /** RESOLVED (fixed) or ABANDONED (could not be pursued). CLOSED = resolved and reported. */
    status: z.enum(['RESOLVED', 'CLOSED', 'ABANDONED']).default('RESOLVED'),
});
export const caseListQuerySchema = z.object({
    status: caseStatusSchema.optional(),
    open: z.preprocess((v) => v === 'true' || v === true, z.boolean()).optional(),
    site: z.string().optional(),
    q: z.string().max(200).optional(),
    limit: z.coerce.number().int().min(1).max(500).default(100),
});
//# sourceMappingURL=case.js.map